export const GET_CATEGORY_FOR_REGISTER_WARRANTY_DATA = 'GET_CATEGORY_FOR_REGISTER_WARRANTY_DATA';

export const GET_CATEGORY_FOR_REGISTER_WARRANTY_DATA_SUCCESS = 'GET_CATEGORY_FOR_REGISTER_WARRANTY_DATA_SUCCESS';

export const GET_CATEGORY_FOR_REGISTER_WARRANTY_DATA_FAILED = 'GET_CATEGORY_FOR_REGISTER_WARRANTY_DATA_FAILED';
